<!-- 热门课程榜单列表-->
<template>
  <div :class="['hotSale-index', { inApp: $root.$data.isApp || $root.miniprogram }]">
    <common-title titleName="课程列表" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <template v-if="!listEmpty">
      <!-- <HotSaleSwiper
        v-if="hotList.length"
        :hotList="hotList"
      />-->

      <!-- 一级标签显示区域 -->
      <div
        :class="['course_classify_box',{ course_classify_box_inApp: $root.$data.isApp || $root.miniprogram }]"
      >
        <div
          :class="['course_classify_item',activeFirstLevelKey === item[0] ? 'course_classify_item_active' : '']"
          v-for="item in firstClassifyList"
          :key="item[0]"
          @click="onChangeFirstLevelCategory(item[0])"
        >
          {{ item[0] }}
        </div>
      </div>

      <!-- 二级标签显示区域 -->
      <div
        :class="['sub_category_box',{ sub_category_box_inApp: $root.$data.isApp || $root.miniprogram }]" 
        v-if="currentSecondLevelCategories && currentSecondLevelCategories.length > 0 && activeFirstLevelKey !== '全部'"
        >
        <div
          :class="['sub_category_item', activeSecondLevelKey === category ? 'sub_category_active' : '']"
          v-for="category in currentSecondLevelCategories"
          :key="category"
          @click="onChangeSecondLevelCategory(category)"
        >
          {{ category }}
        </div>
      </div>

      <div class="course_list">
        <div
          class="course_item"
          v-for="(item, index) in courseInfoData"
          :key="item.productId"
          @click="goDateil(item)"
        >
          <div class="course_content">
            <div class="course_img_box">
              <img class="course_img_cover" :src="item.coverMobile" alt />
              <img
                class="course_img_icon"
                v-if="index === 0 || index === 1 || index === 2"
                :src="`https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hot_coure_top${
                  index + 1
                }.png`"
                alt
              />
            </div>
            <div class="course_info">
              <div class="course_title">{{ item.name }}</div>
              <div class="course_tags">
                <TagComponent
                  v-for="(tagItem, tagIndex) in tagType(item)"
                  :key="tagIndex"
                  :text="tagItem"
                  :color="['套餐', '电子书'].includes(tagItem) ? 'blue' : 'yellow-no-bg'"
                />
              </div>
              <div class="course_time" v-if="item.startTime">
                上课时间 {{ item.startTime.slice(0, 10) }}
              </div>
            </div>
          </div>
          <div class="course_bottom">
            <img
              class="course_bottom_icon"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hot_shop_icon.png"
              alt
            />
            <div class="course_bottom_num">
              {{
                Number(item.setType == 1 ? item.actualSales : item.realSales) +
                Number(item.initialSales)
              }}人已购买
            </div>

            <!-- 划线价 -->
            <del
              v-if="
                (item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount) ||
                item.promotionLabel
              "
              class="course_line_price"
              >￥{{ item.originalPrice }}</del
            >

            <div class="course_price_box">
              <!-- 拼团价 -->
              <div
                class="course_price_tip"
                v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
              >
                拼团价
              </div>

              <!-- 促销价 -->
              <div class="course_price_tip" v-else-if="item.promotionLabel">
                {{
                  item.promotionLabel === 1
                    ? '折后价'
                    : item.promotionLabel === 4
                    ? '券后价'
                    : '限时价'
                }}
              </div>

              <!-- 价格icon -->
              <div
                class="course_price_icon"
                v-if="
                  (item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount) ||
                  !(item.sellPrice === 0 && !item.promotionLabel)
                "
              >
                ￥
              </div>

              <!-- 价格 -->
              <div
                class="course_price_num"
                v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
              >
                {{ item.productDiscountRespVO.discountMinPrice }}
              </div>

              <!-- 免费 -->
              <div class="course_price_free" v-else>
                {{ item.sellPrice === 0 && !item.promotionLabel ? '免费领取' : item.sellPrice }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="course-list">
        <h3 class="hotListTitle">课程榜单</h3>
        <div v-for="(item, keys) in courseInfoData" :key="keys" @click="goback()">
          <CombinationCard v-if="item.setType === 1" :key="keys" :item="item" />
          <HotCourseCard v-else :key="keys" :item="item" />
        </div>
      </div>-->
    </template>
    <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />
    <Foot />
  </div>
</template>

<script>
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
// eslint-disable-next-line import/no-cycle
import { reqCombinationlist } from '@/api/combination';
// eslint-disable-next-line import/no-cycle
import { reqMajorAd, reqProducts, reqHotEvaluation, reqProductCategoryName } from '@/api/home';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Foot from '@/components/foot/privacy.vue';
import { resetProductData, resetCoursePackage } from '@/utils/tools';
import HotSaleSwiper from './components/hotSaleSwiper';
import TagComponent from '@/components/commonComponents/TagComponent.vue';

export default {
  data() {
    return {
      courseInfoData: [],
      ids: [],
      listEmpty: false,
      hotList: [],
      activeFirstLevelKey: '全部', // 一级标签的高亮状态
      activeSecondLevelKey: '', // 二级标签的高亮状态
      firstClassifyList: new Map([]),
      categoryList: [], //分类ids
      subCategoryMap: new Map(), // 存储一级标签与二级标签的映射关系
      currentFirstLevelCategory: '', // 当前选中的一级标签
      currentSecondLevelCategories: [], // 当前一级标签下的二级标签列表
    };
  },

  components: {
    HotCourseCard,
    CombinationCard,
    EmptyData,
    Foot,
    HotSaleSwiper,
    TagComponent,
  },

  computed: {},
  created() {
    document.documentElement.scrollTop = 0;
    window.pageYOffset = 0;
    document.body.scrollTop = 0;
  },
  mounted() {
    this.getProductEvaluation();
    this.getCourseAd();
    // if (this.$root.$data.isApp) {
    //   this.getCourseAd();
    // } else {
    //   const list = sessionStorage.getItem('HOTSALELIST');
    //   this.courseInfoData = JSON.parse(list);
    //   if (!this.courseInfoData.length) {
    //     this.listEmpty = true;
    //   }
    // }
    if (this.$root.miniprogram) {
      gio('track', 'PageAccess_event', {
        beforePageName_var: '课程页',
        functionName_var: '专享课列表',
        platform_var: '启航考研小程序',
      });
    }
  },
  destroyed() {},
  methods: {
    goDateil(item) {
      this.goback();
      if (item.setType === 1) {
        this.enterDetailsPack(item);
      } else {
        this.enterDetailsProd(item);
      }
      if (this.$root.miniprogram) {
        gio('track', 'xcxadShown_event', {
          adPosition_var: '专享轻学课',
          pageName_var: '课程',
          adId_var: this.$route.query.recommendId,
          adName_var: '',
          examType_var: this.$route.query.examType,
          courseName_var: item.name,
          platform_var: '启航考研小程序',
        });
      }
    },
    tagType(val) {
      const type = [];
      if (val.isUnionDiscount) {
        type.push('联报优惠');
      }
      if (val.isSingleDiscount) {
        type.push('单减活动');
      }
      if (val.isCouponDiscount) {
        type.push('优惠券');
      }
      if (val.productDiscountRespVO && val.productDiscountRespVO.isFullDiscount) {
        type.push('满减活动');
      }
      // 增加购课增好礼标签
      if (val.productDiscountRespVO && val.productDiscountRespVO.isBuyGiftGiveawaysDiscount) {
        type.push('购课赠好礼');
      }
      // 整改暂时注释分期
      /* if (val.huabeiStagingActivity) {
          type.push(`${val.huabeiStagingActivity.maxNumberOfPeriod}期分期免息`);
        } */
      if (val?.isEbook) {
        type.push('电子书');
      }
      if (val?.setType == 1) {
        type.push('套餐');
      }
      return type;
    },
    //处理一级标签切换
    onChangeFirstLevelCategory(firstLevelCategory) {
      this.activeFirstLevelKey = firstLevelCategory;
      this.currentFirstLevelCategory = firstLevelCategory;
      this.activeSecondLevelKey = '';
      
      // 如果选中的是"全部"，直接显示所有课程
      if (firstLevelCategory === '全部') {
        this.courseInfoData = this.firstClassifyList.get('全部') || [];
        this.currentSecondLevelCategories = [];
        return;
      }
      
      // 获取该一级标签下的所有课程
      this.courseInfoData = this.firstClassifyList.get(firstLevelCategory) || [];
      // 获取该一级标签下的二级标签列表
      const secondLevelMap = this.subCategoryMap.get(firstLevelCategory);
      if (secondLevelMap) {
        this.currentSecondLevelCategories = Array.from(secondLevelMap.keys());
        // 自动选中第一个二级标签
        if (this.currentSecondLevelCategories.length > 0) {
          this.activeSecondLevelKey = this.currentSecondLevelCategories[0];
          // 获取第一个二级标签下的所有课程
          this.courseInfoData = secondLevelMap.get(this.currentSecondLevelCategories[0]);
        }
      } else {
        this.currentSecondLevelCategories = [];
      }
    },

    //处理二级标签切换
    onChangeSecondLevelCategory(secondLevelCategory) {
      this.activeSecondLevelKey = secondLevelCategory;
      // 获取该二级标签下的所有课程
      const secondLevelMap = this.subCategoryMap.get(this.currentFirstLevelCategory);
      if (secondLevelMap && secondLevelMap.has(secondLevelCategory)) {
        this.courseInfoData = secondLevelMap.get(secondLevelCategory);
      } else {
        this.courseInfoData = [];
      }

     // console.log('二级标签切换:', secondLevelCategory, '课程列表:', this.courseInfoData);
    },
    goback() {
      sessionStorage.setItem('back', true);
    },
    // 获取热销产品评价轮播
    async getProductEvaluation() {
      const res = await reqHotEvaluation();
      this.hotList = res?.data?.data;
    },
    // 查询广告位
    async getCourseAd() {
      const { code, data } = await reqMajorAd(this.$route.query.recommendId);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      } else {
        this.listEmpty = true;
      }
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};

      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = resetProductData(res?.data || []);
        const resPackage = resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          if (findRes) {
            const { productCategoryId, categoryId } = findRes;
            const cateIdS = child.recommendType === 0 ? productCategoryId : categoryId;
            if (cateIdS) {
              // 使用Set去重，避免重复添加相同的cateIdS
              const uniqueCategoryIds = [...new Set([...this.categoryList, cateIdS])];
              this.categoryList = uniqueCategoryIds;
            }
            if (this.$root.miniprogram) {
              gio('track', 'xcxadShown_event', {
                adPosition_var: '专享轻学课',
                pageName_var: '课程',
                adId_var: this.$route.query.recommendId,
                adName_var: '',
                examType_var: this.$route.query.examType,
                courseName_var: child.name,
                platform_var: '启航考研小程序',
              });
            }
          }
          findRes && allCourse.push(findRes);
        });
        this.courseInfoData = allCourse;
        this.getCategoryList();
      });
    },

    //数据初始化
    async getCategoryList() {
      const ids = this.categoryList.map((id) => `ids=${id}`).join('&');
      let res = await reqProductCategoryName(ids, '/');
      if (res && res.data) {
        // 从API返回的数据中提取并处理分类信息
        const categoryNames = this.extractAndProcessCategories(res.data);

        // 处理完分类数据后，默认选择"全部"选项
        this.$nextTick(() => {
          if (categoryNames.length > 0) {
            // 默认选择"全部"选项，此时会自动选中第一个二级标签
            this.onChangeFirstLevelCategory('全部');
          }
        });
      }
    },
   //从API返回的数据中提取并处理分类信息
    extractAndProcessCategories(categories) {
      const firstLevelMap = new Map();
      const allSecondLevelMap = new Map();
      categories.forEach((category) => {
        if (category.nameWrap) {
          const pathParts = category.nameWrap.split('/');
          // 提取一级标签（倒数第二级）和二级标签（最后一级）
          if (pathParts.length >= 2) {
            const firstLevel = pathParts[pathParts.length - 2]; 
            const secondLevel = pathParts[pathParts.length - 1]; 

            let courseContent = [];
            this.courseInfoData.forEach((course) => {
              if (course.productCategoryId === category.id || course.categoryId === category.id) {
                courseContent.push(course);
              }
            });

            // 如果找到匹配的课程内容，则添加到一级标签下
            if (courseContent.length > 0) {
              if (!firstLevelMap.has(firstLevel)) {
                firstLevelMap.set(firstLevel, []);
              }
              firstLevelMap.get(firstLevel).push(...courseContent);
            }

            // 处理二级标签映射关系
            if (!this.subCategoryMap.has(firstLevel)) {
              this.subCategoryMap.set(firstLevel, new Map());
            }

            const secondLevelMap = this.subCategoryMap.get(firstLevel);
            if (!secondLevelMap.has(secondLevel)) {
              secondLevelMap.set(secondLevel, []);
            }

            // 将课程内容添加到二级标签下
            if (courseContent.length > 0) {
              secondLevelMap.get(secondLevel).push(...courseContent);
            }
            
            // 收集所有二级标签，用于"全部"选项
            if (!allSecondLevelMap.has(secondLevel)) {
              allSecondLevelMap.set(secondLevel, []);
            }
            if (courseContent.length > 0) {
              allSecondLevelMap.get(secondLevel).push(...courseContent);
            }
          }
        }
      });
      this.firstClassifyList.set('全部', this.courseInfoData);
      this.subCategoryMap.set('全部', allSecondLevelMap);

      // 然后将处理好的分类数据添加到firstClassifyList中
      firstLevelMap.forEach((courses, category) => {
        if (!this.firstClassifyList.has(category)) {
          this.firstClassifyList.set(category, courses);
        }
      });

      //console.log('处理后的分类数据:', this.firstClassifyList);
      //console.log('二级标签映射关系:', this.subCategoryMap);
      return ['全部', ...firstLevelMap.keys()];
    },

    // 产品进入详情
    enterDetailsProd(courseInfo) {
      const { productSkipConfigRespVO, productId } = courseInfo;
      const { query } = this.$route;
      // 判断是否App
      if (this.$root.$data.isApp) {
        if (productSkipConfigRespVO?.source === 1 && productSkipConfigRespVO?.skipType === 0) {
          // 外部产品
          this.$sendToApp('openBrowser', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
        } else if (
          // 淘宝产品
          productSkipConfigRespVO?.source === 1 &&
          productSkipConfigRespVO?.skipType === 1
        ) {
          this.$sendToApp('openTaobao', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
        } else {
          this.$sendToApp('goCourseDetail', Number(productId), false);
        }
        return;
      }
      if (productSkipConfigRespVO?.source === 1) {
        // 外部产品
        window.open(productSkipConfigRespVO?.mobileSkipUrl);
        return;
      }
      const { roomId } = this.$route.query;
      if (roomId) {
        // 直播间内的推荐课程
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
            liveRoomId: roomId,
            beforePageName: 6,
          },
        });
        // window.open(`${window.location.origin}/ark/courseDetail?courseId=${productId}&liveRoomId=${roomId}&beforePageName=6`)
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
            beforePageName: 6,
            ...query,
          },
        });
      }
    },

    // 套餐进入详情
    enterDetailsPack(courseInfo) {
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goToCombinationCourse', Number(courseInfo.packageId), false);
        return;
      }
      const { roomId } = this.$route.query;
      const { query } = this.$route;
      if (roomId) {
        this.$router.push({
          path: '/combinationCourse',
          query: {
            combinationId: courseInfo.packageId,
            liveRoomId: roomId,
          },
        });
      } else {
        this.$router.push({
          path: '/combinationCourse',
          query: {
            combinationId: courseInfo.packageId,
            ...query,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  height: 0;
}
.hotSale-index {
  width: 100%;
  min-height: 100vh;
  padding-top: 191px;
  font-family: PingFangSC, PingFang SC;
  background: #f7f8fc;
  &.inApp {
    padding-top: 95px;
  }

  .course-list {
    padding: 40px;
    .hotListTitle {
      margin-bottom: 32px;
      color: #111;
      font-weight: 500;
      font-size: 32px;
      line-height: 44px;
    }
  }

  .course_classify_box {
    position: fixed;
    left: 0;
    top: 100px;
    height: 91px;
    width: 100%;
    display: flex;
    gap: 45px;
    background: #ffffff;
    padding: 0 36px;
    z-index: 6;
    overflow-x: auto;

    .course_classify_item {
      flex-shrink: 0;
      height: 91px;
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      line-height: 91px;
    }

    .course_classify_item_active {
      color: #ff7f41;
    }

    .course_classify_item_active::after {
      content: '';
      position: relative;
      display: block;
      width: 29px;
      height: 7px;
      bottom: 7px;
      left: 50%;
      transform: translateX(-50%);
      background: #ff7f41;
    }
  }

  .course_classify_box_inApp {
    top: 0;
  }

  .course_list {
    padding: 29px 36px 0;
    min-height: calc(100vh - 192px);
    // min-height: 100vh;
    .course_item {
      width: 678px;
      height: 239px;
      background: #ffffff;
      border-radius: 14px;
      border: 1px solid #f1d8b8;
      margin-bottom: 22px;
      overflow: hidden;

      .course_content {
        height: 173px;
        width: 100%;
        overflow: hidden;

        .course_img_box {
          float: left;
          position: relative;
          height: 136px;
          width: 188px;
          margin-top: 20px;
          margin-left: 18px;

          .course_img_cover {
            height: 100%;
            width: 100%;
            border-radius: 11px;
          }
          .course_img_icon {
            position: absolute;
            height: 29px;
            width: 94px;
            top: 0;
            right: 0;
          }
        }

        .course_info {
          float: left;
          width: 438px;
          margin-top: 18px;
          margin-left: 14px;

          .course_title {
            width: 438px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 25px;
            color: #333333;
            line-height: 33px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .course_tags {
            margin-top: 9px;
            height: 29px;
            display: flex;
            gap: 7px;

            .course_tag {
              // width: 69px;
              height: 29px;
              padding: 0 7px 0;
              background: #ff7f41;
              border-radius: 5px;
              font-weight: 400;
              font-size: 18px;
              color: #ffffff;
              line-height: 29px;
            }
          }

          .course_time {
            height: 25px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #999999;
            // line-height: 25px;
            margin-top: 18px;
          }
        }
      }
      .course_bottom {
        position: relative;
        height: 64px;
        width: 100%;
        background: #fff9e9;
        border-radius: 0px 0px 14px 14px;
        border: 1px solid #f1d8b8;
        display: flex;
        align-items: center;

        .course_bottom_icon {
          display: block;
          height: 29px;
          width: 29px;
          margin-left: 18px;
        }
        .course_bottom_num {
          height: 31px;
          font-weight: 400;
          font-size: 22px;
          color: #999999;
          line-height: 31px;
          margin-left: 7px;
        }

        .course_line_price {
          position: absolute;
          top: 18px;
          right: 249px;
          height: 31px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #999999;
          line-height: 31px;
        }

        .course_price_box {
          position: absolute;
          top: 0;
          right: 0;
          height: 65px;
          width: 243px;
          background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hot_price_bkg.png')
            no-repeat;
          background-size: cover;
          display: flex;
          align-items: center;
          justify-content: center;

          .course_price_tip {
            height: 25px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #ffffff;
            line-height: 33px;
          }

          .course_price_icon {
            height: 25px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 25px;
            color: #ffffff;
            line-height: 33px;
          }

          .course_price_num {
            height: 51px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 36px;
            color: #ffffff;
            line-height: 51px;
          }

          .course_price_free {
            height: 40px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 29px;
            color: #ffffff;
            line-height: 40px;
          }
        }
      }
    }
  }
}
.sub_category_box {
  display: flex;
  flex-wrap: wrap;
  padding: 0 36px;
  gap:0 20px;
  .sub_category_item {
    margin-top: 20px;
    padding: 12px 30px;
    background: #ffffff;
    border-radius: 27px;
    border: 2px solid #f1f1f1;
    text-align: center;
    font-weight: 400;
    font-size: 25px;
    color: #666666;
  }
}
.sub_category_active{
  background: #ff6c02 !important;
  color: #ffffff !important;

}

::v-deep .topType {
  display: none;
}

::v-deep .common-foot {
  position: relative;
}
</style>
